import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ChristmasDayIcon from 'yoda-core-components/lib/assets/svg/christmas-day.svg';
import FathersDayIcon from 'yoda-core-components/lib/assets/svg/fathers-day.svg';
import HalloweenDayIcon from 'yoda-core-components/lib/assets/svg/halloween-day.svg';
import MothersDayIcon from 'yoda-core-components/lib/assets/svg/mothers-day.svg';
import ValentinesDayIcon from 'yoda-core-components/lib/assets/svg/valentines-day.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './HolidayMessaging.css';

const cx = classNames.bind(styles);

const iconsMap = {
    'christmas-day': <ChristmasDayIcon />,
    'fathers-day': <FathersDayIcon />,
    'halloween-day': <HalloweenDayIcon />,
    'mothers-day': <MothersDayIcon />,
    'valentines-day': <ValentinesDayIcon />,
};

const HolidayMessaging = memo(
    ({ holidayMessage }) =>
        holidayMessage && (
            <div
                className={`${cx('holidayMessageContainer')} ${dt([
                    'box-border',
                    'flex',
                    'items-center',
                ])}`}
            >
                <span
                    data-automation-id="holidayMessageIcon"
                    className={`${cx('holidayMessageIcon')} ${dt(['align-middle'])}`}
                >
                    <Icon
                        iconType="svg"
                        pathClassName={cx('iconPath')}
                        className={cx('svg-icon')}
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        name={holidayMessage.holidayIcon}
                    >
                        {iconsMap[holidayMessage.holidayIcon]}
                    </Icon>
                </span>
                <span
                    className={`${cx('holidayMessage')} ${dt([
                        'font-open-sans-semibold',
                        'text-small',
                        'smMd:!text-base',
                        'text-brand-red',
                        'align-middle',
                        'pl-1',
                        'italic',
                    ])}`}
                >
                    <span>{holidayMessage.holidayMessage}</span>
                </span>
            </div>
        )
);

HolidayMessaging.defaultProps = {
    holidayMessage: {},
};

HolidayMessaging.propTypes = {
    holidayMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default HolidayMessaging;
